module.exports = __webpack_public_path__ + "img/logotipo-mercafacil-dark.54e00dac.svg";